angular.module('app').controller('AppointmentListSettingsCtrl',
    ['$scope', 'SettingService', 'ListService', 'AprimaAnalytics',
        function ($scope, SettingService, ListService, AprimaAnalytics) {
            'use strict';

            AprimaAnalytics.sendPageView('/Settings/Schedule');

            var loadingOption = {
                    Description: 'Loading...'
                },
                appointmentDashboardSettings = SettingService.getAppointmentsListSettings();

            var findById = function (list, id) {
                return !id || _.find(list, {'Id': id});
            };

            var loadSettings = function () {
                $scope.apptOptions = {
                    calendars: [loadingOption]
                };

                $scope.settings = {
                };

                ListService.getList('calendar').then(function (list) {
                    var currentCalendarId = appointmentDashboardSettings && appointmentDashboardSettings.calendarId;
                    $scope.apptOptions.calendars = list;
                    $scope.settings.appointmentsCalendar = findById($scope.apptOptions.calendars, currentCalendarId);
                });

                $scope.settings.displayEndTime = appointmentDashboardSettings && appointmentDashboardSettings.displayEndTime;

                var badgeSettings = SettingService.getAppointmentsBadgeSettings();
                $scope.settings.hideDischarged = badgeSettings && badgeSettings.hideDischarged;
            };

            $scope.mode = 'unlocked';

            $scope.saveAppointmentsTileSettings = function () {
                SettingService.setAppointmentsListSettings({
                    calendarId: $scope && $scope.settings && $scope.settings.appointmentsCalendar && $scope.settings.appointmentsCalendar.Id,
                    displayEndTime : $scope && $scope.settings && $scope.settings.displayEndTime
                });

                SettingService.updateNativeSettings();
            };

            $scope.saveHideDischargedOption = function () {
                AprimaAnalytics.sendEvent('user', 'click', 'hide discharge');
                SettingService.setAppointmentsBadgeSettings({
                    hideDischarged: $scope && $scope.settings && $scope.settings.hideDischarged
                });

                SettingService.updateNativeSettings();
            };

            loadSettings();

        }]);
